import React from 'react';
import { compose } from 'ramda';

import StoreProvider from 'components/StoreProvider/StoreProvider';

const { connect, selectors } = StoreProvider;

const ForAdminOnly = ({
  isAdmin,
  children,
}: {
  isAdmin: boolean;
  children: React.ReactNode;
}) => {
  if (isAdmin) {
    return children;
  }

  return null;
};

export default compose(
  connect((state) => ({
    isAdmin: selectors.authSelectors.isDeepTrueAdmin(state),
  }))
)(ForAdminOnly);
